import { MENU_ITEMS } from "../../data/site";

const MenuCard = ({ item }) => (
  <article
    data-testid={`menu-card-${item.id}`}
    className="card-print group flex flex-col overflow-hidden"
  >
    <div className="h-64 overflow-hidden border-b-2 border-[#1A1A1A] md:h-72">
      <img
        src={item.img}
        alt={item.name}
        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        style={{ objectPosition: item.pos || "50% 50%" }}
        loading="lazy"
      />
    </div>
    <div className="flex flex-1 flex-col p-6">
      <h3 className="text-xl font-black uppercase tracking-tight text-[#1A1A1A]">
        {item.name}
      </h3>
      <p className="mt-2 flex-1 text-sm font-medium text-[#4A4A4A]">
        {item.desc}
      </p>
    </div>
  </article>
);

export const MenuSection = () => {
  return (
    <section id="menu" data-testid="menu-section" className="py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <p className="font-script text-2xl text-[#E63946] md:text-3xl">
          Menümüz
        </p>
        <h2 className="mt-2 text-4xl font-black uppercase tracking-tighter text-[#1A1A1A] sm:text-5xl">
          Sade. Taze. Efsane.
        </h2>
        <p className="mt-4 max-w-lg text-base font-medium text-[#4A4A4A]">
          Az ama öz. Her ürün, her gün taze malzemeyle hazırlanır.
        </p>
        <div className="mt-10 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {MENU_ITEMS.map((item) => (
            <MenuCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};
